// /home/ubuntu/avaai_dashboard/frontend/src/utils/auth.ts
export const TOKEN_KEYS = [
    "ava_session_token", // PRIMARY
    "ava_token",
    "token",
    "access_token",
];
export function getAuthToken() {
    for (const key of TOKEN_KEYS) {
        const local = localStorage.getItem(key);
        if (local)
            return local;
        const session = sessionStorage.getItem(key);
        if (session)
            return session;
    }
    return null;
}
export function setAuthToken(token) {
    // Write ONLY to primary key moving forward
    localStorage.setItem("ava_session_token", token);
    sessionStorage.setItem("ava_session_token", token);
}
export function clearAuthToken() {
    for (const key of TOKEN_KEYS) {
        localStorage.removeItem(key);
        sessionStorage.removeItem(key);
    }
}
// =========================================================
// HARD LOGOUT (FORCE SESSION CLEAR)
// =========================================================
export function hardLogout() {
    if (typeof navigator !== "undefined" &&
        navigator.onLine === false) {
        const confirmed = window.confirm("You are currently offline. Logging out will end Local Mode access until you reconnect to the internet. Do you want to continue?");
        if (!confirmed) {
            return;
        }
    }
    try {
        localStorage.removeItem("ava_token");
        sessionStorage.removeItem("ava_token");
        sessionStorage.removeItem("token");
        // Clear cookies (best effort)
        document.cookie.split(";").forEach(c => {
            document.cookie = c
                .replace(/^ +/, "")
                .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
        });
        window.location.replace("/login?logged_out=1");
    }
    catch (err) {
        console.error("Hard logout failed:", err);
    }
}
